/*
* カルーセル（Embla Carousel）
*/
import EmblaCarousel from 'embla-carousel';

export default class EmblaSlider {
  constructor() {
    this.$emblaContainer = document.querySelector('[data-target="emblaContainer"]');
    this.$sliderPagination = document.querySelector('[data-target="sliderPagination"]');
    this.$sliderImages = document.querySelectorAll('[data-target="sliderImage"]');
  }

  // projects details
  detailsSlider() {
    const slideIndex = this.$sliderImages.length;

    if (slideIndex > 1) {
      const viewportNode = this.$emblaContainer.querySelector('.embla__viewport');
      const emblaApi = EmblaCarousel(viewportNode, {
        loop: false,
        align: 'start'
      });

      // サムネイルページネーション生成
      const images = this.$sliderImages;
      this.$sliderPagination.innerHTML = Array.from(images).map((img, index) => {
        const thumbnail = img.getAttribute('style').replace(/"/g, '');
        return `<div class="embla__dot" data-index="${index}" style="${thumbnail}"></div>`;
      }).join('');

      const dots = this.$sliderPagination.querySelectorAll('.embla__dot');
      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          emblaApi.scrollTo(Number(dot.dataset.index));
        });
      });

      const updateDots = () => {
        const selected = emblaApi.selectedScrollSnap();
        dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === selected);
        });
      };

      emblaApi.on('select', updateDots);
      emblaApi.on('init', updateDots);
    } else {
      this.$emblaContainer.classList.add('not-slider');
    }
  }

  detailsAttachEvent() {
    if (this.$emblaContainer) {
      window.addEventListener('DOMContentLoaded', () => {
        this.detailsSlider();
      });
    }
  }
}
